import * as React from "react";

import { Outlet, createRootRoute, useMatchRoute } from "@tanstack/react-router";
import Navbar from "@/components/application/components/Navbar";
import Header from "@/components/Header";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const matchRoute = useMatchRoute();

  return (
    <React.Fragment>
      {matchRoute({ to: "/" }) ? (
        <Header />
      ) : matchRoute({ to: "/sign-in" }) ||
        matchRoute({ to: "/sign-up" }) ||
        matchRoute({ to: "/maintenance" }) ||
        matchRoute({ to: "/articles/quiz-results/$slug" }) ||
        matchRoute({ to: "/books/quiz-results/$slug" }) ? (
        ""
      ) : (
        <Navbar />
      )}
      <Outlet />
    </React.Fragment>
  );
}
